import { decryptData, encryptData } from "config/config";
import { instance as axios } from "config/axiosInstance";
import { getBrowserName, isLoggedIn } from "config/utils";
import Cookies from "js-cookie";


export const getSeo = async (data) => {
  try {
    const access_token = Cookies.get("access_token") || isLoggedIn();

    const payload = {
      ...data,
    };

    const response = await axios.get("/get-seo-details", { params: payload });
    return response.data;
  } catch (err) {
    console.error("getSeo API Error:", err);
    throw err;
  }
};
